import React, {Dispatch, FC, SetStateAction} from "react";
import {LearnModule} from "../../../../lib/src/api/repositories/learn-repository";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";
import {BulkDeleteLearnModuleModal} from "../../modals/Bulk/BulkDeleteLearnModuleModal";
import {useModal} from "@jane/lib/src/components/layout/ModalProvider";

export const ModuleContextMenu: FC<{ selected: string[], setSelected: Dispatch<SetStateAction<string[]>>, modules: LearnModule[], open: boolean, setOpen: Dispatch<SetStateAction<boolean>>, reload: () => void}> = (props) => {
  const {open: bulkDeleteModuleModal} = useModal({title: 'Archiveer modules', body: <BulkDeleteLearnModuleModal selected={props.selected} modules={props.modules} reload={props.reload} />, size: 'md'})
  return <>
    {props.open && <>
      <div className={'bg-[#0001] fixed inset-0 z-10'} onClick={() => props.setOpen(false)}></div>
      <div className={'absolute z-10 border border-slate-100 rounded-sm shadow-lg top-8 right-0 bg-white flex flex-col items-stretch'}>
        <button className={'px-4 py-2 flex items-center hover:bg-slate-50 font-medium'} onClick={() => {
          bulkDeleteModuleModal()
          props.setOpen(false)
          props.setSelected([])
        }}>
          <div className={'h-8 w-8 flex items-center justify-center'}>
            <FontAwesomeIcon icon={faTrash} className={'text-brand-primary'}  />
          </div>
          <div className={'whitespace-nowrap'}>Archiveren</div>
        </button>
      </div>
    </>}
  </>
}